import React, { useEffect, useState } from "react";
import * as cls from "./notificationsSummaries.module.scss";
import ListItem from "../../resources/icons/ListItem";
import { useDispatch, useSelector } from "react-redux";
import ModalNotifications from "../../components/modalnotifications/ModalNotifications";
import {
  currentNotificationAction,
  showNotificationDetailAction,
} from "../../redux/actions/actions";
import { Table, TableModel } from "../../components/tableLoader";
import {
  ErrataView,
  WidgetFrame,
} from "../../../personal-studio-components/studio";
import { ErrataViewInfo } from "../../../personal-studio-components/service/ErrataViewInfo";
const columnsHeaders = {
  planning_event_id: "planning_event_id",
  Блокирующее: "Блокирующее",
};
export default function NotificationsSummaries({ notificationsArchive }) {
  const dispatch = useDispatch();
  const { open } = useSelector((state) => state.notifications);
  const [key, setKey] = useState(0);
  const { notificationsSummaries } = useSelector(
    (state) => state.notifications
  );
  const { isDead_lock } = useSelector((state) => state.deadLock);
  const [data, setData] = useState(null);
  const handleModalOpen = (data) => {
    dispatch(currentNotificationAction(data));
    dispatch(showNotificationDetailAction(true));
    setKey((prevKey) => prevKey + 1);
  };

  useEffect(() => {
    if (notificationsSummaries && !notificationsSummaries.errors) {
      const tmp = { ...notificationsSummaries };
      tmp.columns.forEach((col) => {
        if (col.field === "is_event_actual") {
          col.type = "jsx";
        }
        if (col.field === "sys_creation_date") {
          col.type = "date";
        }
      });
      tmp.rows = tmp.rows.map((row) => {
        return {
          ...row,
          onClick: () => {
            handleModalOpen({
              is_event_actual: row.is_event_actual,
              planning_event_id: row.planning_event_id,
            });
          },
          is_event_actual: (
            <div className={cls.notifications_summaries_table_td}>
              {row.is_event_actual ? (
                <span className={cls.notifications_summaries_td_span}>
                  Подтверждено
                </span>
              ) : (
                <span className={cls.notifications_summaries_td_span_confirm}>
                  Требуется
                </span>
              )}
            </div>
          ),
        };
      });

      tmp.columns = tmp.columns.filter(
        (col) => !(col.headerName in columnsHeaders)
      );
      setData(tmp);
    }
  }, [notificationsSummaries]);
  const menu = [
    {
      icon: "none",
      name: "Смотреть архив",
      href: notificationsArchive,
      target: "blank",
    },
  ];

  if (notificationsSummaries?.errors) {
    return (
      <WidgetFrame icon="survey" title="Уведомления и обращения" menu={menu}>
        {notificationsSummaries.error_type === "info" ? (
          <ErrataViewInfo errata={notificationsSummaries} />
        ) : (
          <ErrataView errata={notificationsSummaries} />
        )}
      </WidgetFrame>
    );
  }

  if (data)
    return (
      <WidgetFrame icon="survey" title="Уведомления и обращения" menu={menu}>
        <div>
          <p className={cls.notifications_summaries_info}>
            Обращаем Ваше внимание, что в данном разделе размещаются уведомления
            за текущий месяц и не прочитанные уведомления. Уведомления
            предыдущих периодов вы можете найти в архиве.
          </p>
          <Table {...data} />
        </div>
        <div className={cls.notifications_summaries_footer_wrapper}></div>
        {open && !isDead_lock && (
          <ModalNotifications key={key} setNotifiactionsData={setData} />
        )}
      </WidgetFrame>
    );
  return;
  return (
    <section className={cls.notifications_summaries_wrapper}>
      <div className={cls.notifications_summaries_container}>
        <div className={cls.notifications_summaries_header_wrapper}></div>
        <div className={cls.notifications_summaries_content_wrapper}>
          {/* <div className={cls.notifications_summaries_content_title_wrapper}>
            <div className={cls.notifications_summaries_content_title_inner}>
              <div className={cls.notifications_summaries_content_icon}>
                <ListItem />
              </div>
              <div className={cls.notifications_summaries_content_title}>
                Уведомления и обращения
              </div>
            </div>
            <div className={cls.notifications_summaries_archive}>
              Смотреть архив
            </div>
          </div> */}

          <p className={cls.notifications_summaries_info}>
            Обращаем Ваше внимание, что в данном разделе размещаются уведомления
            за текущий месяц и не прочитанные уведомления. Уведомления
            предыдущих периодов вы можете найти в архиве.
          </p>
          <Table {...data} />
        </div>
        <div className={cls.notifications_summaries_footer_wrapper}></div>
      </div>
      {open && <ModalNotifications key={key} setNotifiactionsData={setData} />}
    </section>
  );
}
